<template>
  <article
    class="garage-no-premium-sidebar"
    v-if="suggestedGarages?.length"
  >
    <div class="garage-no-premium-sidebar__header">
      <h2>{{ title || 'Polecane warsztaty' }}</h2>
    </div>
    <div
      class="garage-no-premium-sidebar__carousel"
      :class="{
      'carousel-right-gradient': (suggestedGarages.length > currenSlide + 1),
      'carousel-left-gradient': (currenSlide > 0)
    }"
    >
      <Carousel
        :items-to-show="itemsToShow"
        v-model="currenSlide"
        :mouse-drag="false"
      >
        <Slide
          v-for="suggestedGarage in suggestedGarages"
          :key="suggestedGarage.id"
        >
          <GarageSuggested :suggestedGarage="suggestedGarage" />
        </Slide>


        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </article>
</template>

<script
  setup
  lang="ts"
>
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, RankingJsonldSuggestedGarageReadRankingRead } from '~/api/docs/api';
import GarageSuggested from './GarageSuggested.vue';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  suggestedGarages?: RankingJsonldSuggestedGarageReadRankingRead[];
  itemsToShow: number;
  title?: string;
}

// data
const currenSlide: Ref<number> = ref(0);

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();


</script>

<style lang="scss">
@import url('assets/styles/components/garage-no-premium-sidebar.scss');
</style>